import ConfirmationPrompt from './ConfirmationPrompt'

export default ConfirmationPrompt
